module.exports = __webpack_public_path__ + "img/awards_03.9295931f.png";